import React from "react";

// Compact SVG sparkline. Zero dependencies. Renders a filled area + line +
// current point. Handles all-zero series gracefully.
export default function Sparkline({
  data = [],
  height = 56,
  width = 320,
  strokeColor = "#0f172a",
  fillColor = "rgba(16,185,129,0.14)",
  showDots = true,
  formatValue = (v) => v,
  ariaLabel = "Trend sparkline",
}) {
  if (!data || data.length === 0) {
    return <div className="text-xs text-slate-400">No trend yet.</div>;
  }
  const values = data.map((d) => (typeof d === "object" ? d.value : d));
  const labels = data.map((d) => (typeof d === "object" ? d.label : ""));
  const max = Math.max(1, ...values);
  const min = Math.min(0, ...values);
  const range = Math.max(1, max - min);
  const n = values.length;
  const stepX = n > 1 ? width / (n - 1) : width;
  const pointY = (v) => height - ((v - min) / range) * (height - 6) - 3;
  const pts = values.map((v, i) => [i * stepX, pointY(v)]);
  const pathD = pts.map((p, i) => `${i === 0 ? "M" : "L"}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
  const areaD = `${pathD} L${width},${height} L0,${height} Z`;
  const last = pts[pts.length - 1];
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height={height}
      preserveAspectRatio="none"
      role="img"
      aria-label={ariaLabel}
    >
      <path d={areaD} fill={fillColor} />
      <path d={pathD} fill="none" stroke={strokeColor} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      {showDots && (
        <>
          <circle cx={last[0]} cy={last[1]} r="4" fill={strokeColor} />
          <circle cx={last[0]} cy={last[1]} r="2" fill="#fff" />
        </>
      )}
      {labels[0] && labels[labels.length - 1] && (
        <>
          <text x="0" y={height - 2} fontSize="9" fill="#94a3b8">{labels[0]}</text>
          <text x={width} y={height - 2} fontSize="9" textAnchor="end" fill="#94a3b8">{labels[labels.length - 1]}</text>
        </>
      )}
      <title>
        {`${labels[labels.length - 1] || "Latest"}: ${formatValue(values[values.length - 1])}`}
      </title>
    </svg>
  );
}
